import React, { useState } from 'react';
import bedShapeOne from '../images/ui_buttons/bed_shape_1_button.png';
import bedShapeTwo from '../images/ui_buttons/bed_shape_2_button.png';
import bedShapeThree from '../images/ui_buttons/bed_shape_3_button.png';
import bedShapeFour from '../images/ui_buttons/bed_shape_4_button.png';
import bedShapeFive from '../images/ui_buttons/bed_shape_5_button.png';
import { useAppContext, SET_SHAPE, SET_BED_SIZE } from '../context/AppContext';

const GardenBedButtons = ({ selectedShape, selectedBedSize }) => {
	const { dispatch } = useAppContext();

	// Logic for choosing selected garden bed shape
	const handleSelectGardenShape = (shapeId) => {
		console.log('GardenBedButtons received click on', shapeId);
		dispatch({ type: SET_SHAPE, payload: shapeId });
	};

	// Logic for choosing selected garden bed size
	const handleSelectGardenSize = (sizeId) => {
		console.log('GardenBedButtons received click on', sizeId);
		dispatch({ type: SET_BED_SIZE, payload: sizeId });
	};

	return (
		<div className='left-side-button-container'>
			<h2>Choose your garden bed shape and size</h2>
			<div className='bed-shape-container'>
				<h3>Bed Shape</h3>
				<div className='bed-shape-button-container'>
					<div className='bed-shape-column'>
						<button
							className={`bed-shape-button ${
								selectedShape === 'bed_shape_1' ? 'selected' : ''
							}`}
							onClick={() => handleSelectGardenShape('bed_shape_1')}>
							<img src={bedShapeOne} alt='Bed Shape 1' className='bed-shape-icon' />
						</button>
						<button
							className={`bed-shape-button ${
								selectedShape === 'bed_shape_3' ? 'selected' : ''
							}`}
							onClick={() => handleSelectGardenShape('bed_shape_3')}>
							<img src={bedShapeThree} alt='Bed Shape 3' className='bed-shape-icon' />
						</button>
						<button
							className={`bed-shape-button ${
								selectedShape === 'bed_shape_5' ? 'selected' : ''
							}`}
							onClick={() => handleSelectGardenShape('bed_shape_5')}>
							<img src={bedShapeFive} alt='Bed Shape 5' className='bed-shape-icon' />
						</button>
					</div>
					<div className='bed-shape-column'>
						<button
							className={`bed-shape-button ${
								selectedShape === 'bed_shape_2' ? 'selected' : ''
							}`}
							onClick={() => handleSelectGardenShape('bed_shape_2')}>
							<img src={bedShapeTwo} alt='Bed Shape 2' className='bed-shape-icon' />
						</button>
						<button
							className={`bed-shape-button ${
								selectedShape === 'bed_shape_4' ? 'selected' : ''
							}`}
							onClick={() => handleSelectGardenShape('bed_shape_4')}>
							<img src={bedShapeFour} alt='Bed Shape 4' className='bed-shape-icon' />
						</button>
					</div>
				</div>
			</div>
			<div className='bed-size-container'>
				<h3>Bed Size</h3>
				<button
					className={`bed-size-button ${selectedBedSize === 12 ? 'selected' : ''}`}
					onClick={() => handleSelectGardenSize(12)}>
					12' x 6'
				</button>
				<button
					className={`bed-size-button ${selectedBedSize === 15 ? 'selected' : ''}`}
					onClick={() => handleSelectGardenSize(15)}>
					15' x 8'
				</button>
				<button
					className={`bed-size-button ${selectedBedSize === 18 ? 'selected' : ''}`}
					onClick={() => handleSelectGardenSize(18)}>
					18' x 9'
				</button>
			</div>
		</div>
	);
};

export default GardenBedButtons;
